import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi, I'm Xuchen Sun, a dedicated Software Engineer based in Markham, Ontario, with <span className="purple">many years </span>of experience <span className="purple">designing, building</span>, and <span className="purple">deploying enterprise-level applications</span>. I specialize in full-stack development, <span className="purple">iOS app development</span>, and <span className="purple">AI-powered applications</span>.
            <br/>
            <br />
            Currently employed as a software developer at <span className="purple">TD Canada Trust</span>. I also independently develop and publish iOS apps on the App Store, including AI chat apps, stock analysis tools, and productivity apps.
            <br />
            <br />
            Passionate about leveraging <span className="purple">large language models</span> and <span className="purple">cloud infrastructure</span> to build innovative products that solve real problems.
          </p>

        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
